<template>
	<section class="tagged">
		<div class="tagged__wrapper">
			<div
				v-for="taggedItem in taggedInfoList"
				class="tagged__item"
				:key="taggedItem.title"
			>
				<div class="tagged__item-img">
					<img
						v-if="taggedItem.logo"
						:src="img(taggedItem)"
						:srcset="`${img(taggedItem)}, ${img2x(taggedItem)} 2x`"
						:alt="taggedItem.title"
					/>
				</div>
				<div class="tagged__item-info">
					<div class="tagged__item-info-type">
						{{ $t(taggedItem.type) }}
					</div>
					<NuxtLink
						:to="taggedItem.url"
						class="tagged__item-info-title"
					>
						{{ taggedItem.title }}
					</NuxtLink>
				</div>
			</div>
		</div>
	</section>
</template>


<script>
export default {
	props: {
		studio: {
			type: Object,
			default: null,
		},
		collection: {
			type: Object,
			default: null,
		},
	},
	computed: {
		taggedInfoList() {
			return [
				...(
					this.studio ? [{
						type: 'studio',
						title: this.studio.name,
						url: this.studio.url,
						logo: this.studio.logo,
					}] : []
				),
				...(
					this.collection ? [{
						type: 'collection',
						title: this.collection.name,
						url: this.collection.url,
						logo: this.collection.logo,
					}] : []
				),
			]
		}
	},
	methods: {
		img(item) {
			return `${this.$config.public.HOST_BACKEND}${item?.logo?.url + '/s.webp'}`;
		},
		img2x(item) {
			return `${this.$config.public.HOST_BACKEND}${item?.logo?.url + '/s2x.webp'}`;
		},
	}
};
</script>
